<template>
  <div>
    <div v-if="!isSmAndDown">
      <div v-if="showFooter">
        <v-footer
          :fixed="fixed"
          class="pa-3"
          :style="
            `left: ${elementPositionLeft}px !important; width: ${elementWidth}px !important`
          "
          height="67"
        >
          <v-layout row wrap align-center v-if="productsQuantity">
            <v-flex xs12 class="mr-3"
              ><h5 v-if="productsQuantity === 1" class="checkout-h5 grey--text">
                {{ productsQuantity }} INGRESSO
              </h5>
              <h5 v-else class="checkout-h5 grey--text">
                {{ productsQuantity }} INGRESSOS
              </h5></v-flex
            >
            <v-flex xs12
              ><h3 class="checkout-h3">
                {{ (productsTotal * 100) | currency }}
              </h3></v-flex
            >
          </v-layout>
          <v-btn
            v-if="
              (products && products.length) ||
                (products2 && products2.products && products2.products.length)
            "
            block
            round
            depressed
            :style="$route.name === 'totem' ? 'height: 45px !important' : ''"
            class="normal-text"
            :class="{ 'btn-disabled': !purchaseStarted }"
            :color="purchaseStarted ? 'primary' : 'info'"
            dark
            :loading="loading"
            @click="purchase"
            >{{
              productsQuantity
                ? 'Continuar'
                : 'Você ainda não selecionou os ingressos'
            }}</v-btn
          >
        </v-footer>
      </div>

      <div v-else class="products-pre-order">
        <v-layout row wrap v-if="productsQuantity">
          <v-flex xs12
            ><h5 v-if="productsQuantity === 1" class="checkout-h5 grey--text">
              {{ productsQuantity }} INGRESSO
            </h5>
            <h5 v-else class="checkout-h5 grey--text">
              {{ productsQuantity }} INGRESSOS
            </h5></v-flex
          >
          <v-flex xs12
            ><h3 class="checkout-h3">
              {{ (productsTotal * 100) | currency }}
            </h3></v-flex
          >
        </v-layout>
        <v-btn
          v-if="
            (products && products.length) ||
              (products2 && products2.products && products2.products.length)
          "
          block
          round
          depressed
          class="normal-text"
          :class="{ 'btn-disabled': !purchaseStarted }"
          :color="purchaseStarted ? 'primary' : 'info'"
          dark
          :loading="loading"
          @click="purchase"
          >{{
            productsQuantity
              ? 'Continuar'
              : 'Você ainda não selecionou os ingressos'
          }}</v-btn
        >
      </div>
    </div>
    <div v-else>
      <v-footer app height="80">
        <div class="products-pre-order mobile-cart">
          <v-layout row wrap justify-end>
            <v-flex xs4>
              <v-layout row wrap v-if="productsQuantity">
                <v-flex xs12
                  ><h5
                    v-if="productsQuantity === 1"
                    class="checkout-h5 grey--text"
                  >
                    {{ productsQuantity }} INGRESSO
                  </h5>
                  <h5 v-else class="checkout-h5 grey--text">
                    {{ productsQuantity }} INGRESSOS
                  </h5></v-flex
                >
                <v-flex xs12
                  ><h3 class="checkout-h3">
                    {{ (productsTotal * 100) | currency }}
                  </h3></v-flex
                >
              </v-layout>
            </v-flex>

            <v-flex xs8>
              <v-btn
                v-if="
                  (products && products.length) ||
                    (products2 &&
                      products2.products &&
                      products2.products.length)
                "
                block
                round
                depressed
                class="normal-text"
                :class="{ 'btn-disabled': !purchaseStarted }"
                :color="purchaseStarted ? 'primary' : 'info'"
                dark
                :loading="loading"
                @click="purchase"
                >{{
                  productsQuantity
                    ? 'Continuar'
                    : 'Você ainda não selecionou os ingressos'
                }}</v-btn
              >
            </v-flex>
          </v-layout>
        </div>
      </v-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setOptions, bootstrap } from 'vue-gtag';
import { incrementStringInSrc } from '../../utils/facebook-pixel';
export default {
  watch: {
    currentStep(value) {
      if (value === 1) {
        console.log('setPurchaseStarted - currentStep - false');
        this.$store.dispatch('setPurchaseStarted', false);
      }
    },
  },
  data: () => ({
    showFooter: true,
    elementPositionLeft: null,
    elementWidth: null,
    scrollPosition: null,
    scrollOffset: 67,
    loading: false,
    scrollPoints: [
      {
        label: 'BtLogo',
        anchor: 'btlogo',
        position: 0,
      },
    ],
  }),
  computed: {
    ...mapGetters({
      tempSelectedSector: 'tempSelectedSector',
      products: 'noSectorProducts',
      products2: 'selectedSector',
      sectorMap: 'sectorMap',
      createOrderInProgress: 'createOrderInProgress',
      store: 'store',
      storeConfigs: 'storeConfigs',
    }),
    currentStep() {
      return this.$store.getters.currentStep;
    },
    pdv() {
      return this.$store.getters.pdv;
    },
    fixed() {
      if (this.$route.name === 'totem') return true;
      if (!this.scrollPosition) return false;
      else if (this.scrollPosition < window.innerHeight) return true;
      else return window.outerHeight > window.innerHeight;
    },
    hasProductsCart() {
      let total = 0;
      this.cartProducts.forEach(p => {
        total += p.length;
      });
      return total;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    facebookPixel() {
      return this.$store.getters.facebookPixel;
    },
    eventDetails() {
      return this.$store.getters.eventDetails;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    eventName() {
      return this.$store.getters.eventName;
    },
    body() {
      return this.$store.getters.body;
    },
    productsQuantity() {
      let total = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            total += v.quantidade;
          });
        });
      }
      return total;
    },
    qtdProductsArray() {
      let array = [];
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            if (
              array.find(a => {
                return a.codigo === v.codigo_produto;
              })
            ) {
              let item = array.find(a => {
                return a.codigo === v.codigo_produto;
              });
              item.qtd += v.quantidade;
            } else
              array.push({
                codigo: v.codigo_produto,
                qtd: v.quantidade,
                min: v.qts_min,
              });
          });
        });
      }
      return array;
    },
    purchaseStarted() {
      let qtd = true;
      qtd = this.qtdProductsArray.map(p => {
        if (p.min) {
          if (!String(p.qtd / p.min).includes('.')) return true;
          else return false;
        } else return true;
      });
      let disabled = !JSON.stringify(qtd).includes('false');
      if (this.productsQuantity === 1)
        document.getElementsByClassName('v-dialog')[0].scrollBy(0, 1);
      return this.productsQuantity > 0 && disabled;
    },
    productsTotal() {
      let total = 0;
      let somador = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            somador += (v.valor + v.valor_conveniencia) * v.quantidade;
          });
        });
        total = somador;
      }
      return total;
    },

    totalWithoutTax() {
      let total = 0;
      let somador = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            somador += v.valor * v.quantidade;
          });
        });
        total = somador;
      }
      return total;
    },

    tiktokPixel() {
      return this.findTokenPerType('tiktok');
    },
    googleAds() {
      return this.findTokenPerType('google_ads');
    },
    googleAnalytics() {
      return this.findTokenPerType('google_analytics');
    },
  },

  methods: {
    getBase64Image(img) {
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL('image/png');
      return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
    },
    handleScroll(event) {
      this.scrollPosition = event.target.scrollTop + event.target.offsetHeight;
      if (this.scrollPosition >= this.scrollPoints[0].position) {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }
    },
    scrollTopDialog() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.getElementsByClassName(
        'v-dialog v-dialog--active v-dialog--persistent'
      )[0].scrollTop = 0;
    },
    gAnalytics() {
      if (this.eventDetails && this.googleAnalytics) {
        let products = [];
        this.cartProducts.forEach(item => {
          item.forEach(p => {
            let product = {
              id: `${this.eventID}-${this.body.codigo_pedido}`,
              name: `${this.eventName} - ${p.nome}`,
              sku: String(p.codigo_produto),
              category: 'Evento',
              price: p.valor,
              quantity: p.quantidade,
            };
            products.push(product);
          });
        });

        this.$gtag.query('event', 'add_to_cart', {
          value: this.productsTotal,
          currency: 'BRL',
          items: products,
        });
      }
    },
    startGoogleAds() {
      const cartToken = this.findCartTokenPerType('google_ads');

      if (cartToken && this.googleAds) {
        this.$gtag.event('conversion', {
          send_to: cartToken.startsWith('AW')
            ? cartToken
            : `${this.googleAds}/${cartToken}`,
          transaction_id: `${this.eventID}-${this.body.codigo_pedido}`,
          event_category: 'Carrinho',
          event_label: 'Total',
          value: this.productsTotal,
          event_value: String(this.productsTotal),
          currency: 'BRL',
        });
      }

      if (this.storeConfigs.googleAnalytics) {
        this.$gtag.event('conversion', {
          send_to: this.storeConfigs.googleAnalytics,
          transaction_id: `${this.eventID}-${this.body.codigo_pedido}`,
          event_category: 'Carrinho',
          event_label: 'Total',
          value: this.productsTotal,
          event_value: String(this.productsTotal),
          currency: 'BRL',
        });
      }
    },
    tiktokAnalytics() {
      window.ttq.track('AddToCart', {
        product_group: 'product_group',
        content_id: `${this.eventID}-${this.body.codigo_pedido}`,
        content_category: 'ecommerce',
        value: this.productsTotal,
        description: 'Total',
        currency: 'BRL',
      });
    },
    checkIfHaveItemsEquals() {
      let array = [];
      let have = false;
      this.cartProducts.forEach(p => {
        p.forEach(t => {
          array = array.concat(t.seat_id);
        });
      });
      array.forEach(seat1 => {
        let i = 0;
        array.forEach(seat2 => {
          if (seat1 === seat2) i++;
          if (i === 2) have = true;
        });
      });
      return have;
    },
    async purchase() {
      this.loading = true;
      if (this.purchaseStarted) {
        if ((await this.checkIfHaveItemsEquals()) && this.sectorMap) {
          this.loading = false;
          await this.$store.dispatch('openSnackbar', {
            message: 'Erro inesperado.',
            color: 'error',
          });
          this.reset();
        } else {
          if (!this.createOrderInProgress) {
            await this.$store
              .dispatch('setCreationCart', this.cartProducts)
              .then(resp => {
                this.loading = false;
                this.$store.commit('SET_CREATE_ORDER_IN_PROGRESS', false);
              })
              .catch(e => {
                this.loading = false;
                this.$store.commit('SET_CREATE_ORDER_IN_PROGRESS', false);
              });
          }
        }
        this.addFacebookPixel();
        this.gAnalytics();
        this.startGoogleAds();
        if (this.tiktokPixel) this.tiktokAnalytics();
      }
      this.loading = false;
    },
    async reset() {
      const evento = this.$store.getters.eventID;
      const checkoutState =
        JSON.parse(localStorage.getItem(`checkoutState`)) || {};
      await this.$store.dispatch('deleteCheckoutState', evento);
      if (
        checkoutState &&
        checkoutState[evento] &&
        checkoutState[evento].userToken
      )
        await this.$store.dispatch('getClientData');
      await this.$store.dispatch('loadCheckoutState', evento);
      await this.$store.dispatch('resetSelection');
      await this.$store.dispatch('setResetPurchase', false);
    },
    isLetter(str) {
      return /[a-zA-Z]/.test(str);
    },
    async addFacebookPixel() {
      let metaPixelStore =
        this.store && this.store.configs && this.store.configs.metaPixel
          ? this.store.configs.metaPixel
          : null;

      if (this.facebookPixel) {
        const facebookIntegrations = this.eventDetails.integracoes_publicas.filter(
          integration => integration.tipo === 'facebook_pixel'
        );

        facebookIntegrations.forEach(integration => {
          var addToCart = document.createElement('img');
          addToCart.src = `https://www.facebook.com/tr?id=${
            integration.credenciais.token
          }&ev=AddToCart&eid=${this.body.codigo_evento}-${
            this.body.codigo_pedido
          }&cd[currency]=BRL&cd[value]=${
            this.totalWithoutTax
          }&cd[content_type]=product&cd[eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}`;

          addToCart.src += `&cd[contents][0][id]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][quantity]=1`;

          addToCart.src = incrementStringInSrc(
            this.cartProducts,
            addToCart.src
          );

          addToCart.style = 'display:none;';
          addToCart.height = 1;
          addToCart.width = 1;
          document.getElementsByTagName('head')[0].appendChild(addToCart);
        });
      }

      if (metaPixelStore) {
        let addToCartStore = document.createElement('img');
        addToCartStore.src = `https://www.facebook.com/tr?id=${metaPixelStore}&ev=AddToCart&eid=${this.body.codigo_evento}-${this.body.codigo_pedido}&cd[currency]=BRL&cd[value]=${this.totalWithoutTax}&cd[content_type]=product`;

        addToCartStore.src += `&cd[contents][0][id]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][quantity]=1`;

        addToCartStore.src = await incrementStringInSrc(
          this.cartProducts,
          addToCartStore.src
        );

        addToCartStore.style = 'display:none;';
        addToCartStore.height = 1;
        addToCartStore.width = 1;
        document.getElementsByTagName('head')[0].appendChild(addToCartStore);
      }
    },
    loadScrollPositions() {
      // var _self = this
      this.scrollPoints.forEach(s => {
        s.position =
          document.getElementById(s.anchor).getBoundingClientRect().top +
          this.scrollOffset;
      });
    },
    setFooterParameters() {
      this.elementPositionLeft = document
        .getElementById('headercard')
        .getBoundingClientRect().left;
      this.elementWidth = document
        .getElementById('headercard')
        .getBoundingClientRect().width;
    },
    findTokenPerType(type) {
      return this.eventDetails &&
        this.eventDetails.integracoes_publicas &&
        this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
        ? this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
            .credenciais.token
        : '';
    },

    findCartTokenPerType(type) {
      return this.eventDetails &&
        this.eventDetails.integracoes_publicas &&
        this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
        ? this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
            .credenciais.add_to_cart
        : '';
    },

    handleResize() {
      this.scrollTopDialog();
      this.setFooterParameters();
      this.loadScrollPositions();
    },
  },
  updated() {
    this.loadScrollPositions();
  },
  created() {
    this.setFooterParameters();
    this.loadScrollPositions();
  },
  mounted() {
    if (this.sectorMap && this.sectorMap.length) this.scrollPosition = 920;
    window.addEventListener('scroll', this.handleScroll, true);
    if (this.eventDetails && this.googleAnalytics) {
      setOptions({
        config: {
          id: `${
            this.isLetter(String(this.googleAnalytics).charAt(0)) ? '' : 'UA-'
          }${this.googleAnalytics}`,
        },
      });
      bootstrap().then(gtag => {
        // all done!
      });
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="stylus" scoped>
@import "~@/assets/product/productsPreOrder.styl"
</style>
